import { render, staticRenderFns } from "./pdp-modal.vue?vue&type=template&id=381e34dd"
import script from "./pdp-modal.vue?vue&type=script&lang=js"
export * from "./pdp-modal.vue?vue&type=script&lang=js"
import style0 from "./pdp-modal.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports